export default __webpack_public_path__ + "static/media/html.e7c45848.gif";